"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStreamFromClient = exports.getPcStateFromClient = exports.getPcIceGatheringStateFromClient = exports.getPcIceConnectionStateFromClient = void 0;
var _reselect = require("reselect");
var _selectors = require("../session/selectors");
var _peerManager = _interopRequireDefault(require("../../utils/peerManager"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var pcStatesSelector = state => state.webRTC.pcStates;
var pcIceConnectionStatesSelector = state => state.webRTC.pcIceConnectionStates;
var pcIceGatheringStatesSelector = state => state.webRTC.pcIceGatheringStates;
var streamSelector = state => state.webRTC.streams;
var _getRoomParameter = (_, _room) => _room;
var _getClientParameter = (_, _room, _client) => _client;
var _getClientProfileKeyParameter = (_, _room, _client, profileKey) => profileKey;
var filterFromClient = (pcStates, _room, _client, profileKey, _myClient) => {
  var isMe = _client === 'janus' || _client === _myClient;
  var peers = _peerManager.default.getPeer({
    _entity: _room,
    _client: isMe ? 'janus' : _client
  });
  if (peers) {
    var _Object$values$find;
    var token = (_Object$values$find = Object.values(peers).find(x => {
      var _x$profile, _x$settings;
      return ((_x$profile = x.profile) === null || _x$profile === void 0 ? void 0 : _x$profile.key) === profileKey && (isMe || (x === null || x === void 0 || (_x$settings = x.settings) === null || _x$settings === void 0 ? void 0 : _x$settings.isInitiator) === false);
    })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.token;
    return pcStates === null || pcStates === void 0 ? void 0 : pcStates[token];
  }
  return undefined;
};

// _client is 'janus' for PC from me to janus, so i need to identify if _client is me or not
var getPcStateFromClient = exports.getPcStateFromClient = (0, _reselect.createSelector)([pcStatesSelector, _getRoomParameter, _getClientParameter, _getClientProfileKeyParameter, _selectors._currentClientSelector], filterFromClient);
var getPcIceConnectionStateFromClient = exports.getPcIceConnectionStateFromClient = (0, _reselect.createSelector)([pcIceConnectionStatesSelector, _getRoomParameter, _getClientParameter, _getClientProfileKeyParameter, _selectors._currentClientSelector], filterFromClient);
var getPcIceGatheringStateFromClient = exports.getPcIceGatheringStateFromClient = (0, _reselect.createSelector)([pcIceGatheringStatesSelector, _getRoomParameter, _getClientParameter, _getClientProfileKeyParameter, _selectors._currentClientSelector], filterFromClient);
var getStreamFromClient = exports.getStreamFromClient = (0, _reselect.createSelector)([streamSelector, _getRoomParameter, _getClientParameter, _getClientProfileKeyParameter, _selectors._currentClientSelector], filterFromClient);